module.exports = __webpack_public_path__ + "img/solution2.1d862a49.jpg";